import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
const { wrapHOC } = FrameworkUtils;

import { userSelector } from 'selectors/user/userSelector';
import Actions from 'actions/Actions';
import RewardFulfillmentMethodModalBindings from 'analytics/bindingMethods/components/globalModals/rewardFulfillmentMethodModal/RewardFulfillmentMethodModalBindings';

const basketSelector = state => state.basket;

const fields = createSelector(userSelector, basketSelector, (user, basket) => ({
    preferredZipCode: user?.preferredZipCode,
    preferredStoreInfo: user?.preferredStoreInfo,
    userId: user?.userId || user?.profileId,
    isSignedInBIUser: user?.beautyInsiderAccount?.vibSegment != null,
    hasMetFreeShippingThreshhold: basket?.remainToFreeShipping == null,
    basket
}));

const functions = dispatch => ({
    pageLoadAnalytics: RewardFulfillmentMethodModalBindings.pageLoad,
    closeChangeMethodModal: () => dispatch(Actions.showChangeMethodModal({ isOpen: false }))
});

const withChangeMethodModalProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withChangeMethodModalProps
};
